<template>
  <div>
    <div :class="'md-layout'" v-if="isFetching">
      <div :class="'md-layout-item md-size-67 md-xsmall-size-80 mx-auto text-center'">
        <span :class="'md-title'">Loading review results</span>
        <md-progress-spinner :class="'md-accent md-flex text-center'" :md-stroke="3" md-mode="indeterminate">
        </md-progress-spinner>
      </div>
    </div>
    <div v-else>
      <div :class="'md-layout'">
        <div :class="'md-layout-item md-size-67 md-xsmall-size-80 mx-auto'">
          <md-card>
            <md-card-header :class="'text-right screen-only'">
              <md-button @click.native="$router.go(-1)" :class="'btn-previous'">
                Back
              </md-button>
              <md-button v-if="!isAdminTI" :class="'md-simple'" :md-ripple="false" @click.prevent="printReport()"
                title="Print this report">
                <span>Print this report</span>
                <md-icon>print</md-icon>
              </md-button>
            </md-card-header>
            <md-card-content>
              <QHeader :q="q" />
              <ComplianceResult :q="q" v-if="q.advisory.rqr_type === rqrTypeEnum.COMPLICE" />
              <QualityResult :q="q" v-if="q.advisory.rqr_type === rqrTypeEnum.QUALITY" />
              <InFlightResult :q="q" v-if="q.advisory.rqr_type === rqrTypeEnum.IN_FLIGHT_REVIEW" />              
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QHeader from "./Header.vue";
import ComplianceResult from "./ComplianceResult.vue";
import QualityResult from "./QualityResult.vue";
import InFlightResult from "./InFlightResult.vue";
import { camelToSnake } from "@/methods/api/requests"
import rqrTypeEnum from "@/enums/rqrType"

export default {
  created() {
    if (!this.canViewReport) {
      this.$router.go(-1);
      this.$toast.show(
        "Only admins, reviewers and RQR leaders can access reports"
      );
      return;
    }

    this.getReview();
  },

  data() {
    return {
      q: {},
      isFetching: false,
      rqrTypeEnum,
    };
  },

  components: {
    QHeader,
    ComplianceResult,
    QualityResult,
    InFlightResult,
  },

  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },

    isReviewer() {
      return this.$store.state.currentProfile === "reviewer" ? true : false;
    },

    isRQRLeader() {
      return this.$store.state.currentProfile === "rqr_leader" ? true : false;
    },

    isAdminTI() {
      return this.$store.state.currentProfile === "adminTi" ? true : false;
    },

    canViewReport() {
      return this.isAdmin || this.isReviewer || this.isRQRLeader ||
        this.isAdminTI ? true : false;
    },
  },

  methods: {
    getReview() {
      this.isFetching = true;
      this.$api
        .request(`reviews/${this.$route.params.id}?users=all`)
        .then((response) => {
          this.q = camelToSnake(response.data[0]);
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    printReport() {
      window.print();
    },
  },

  watch: {
    "$store.state.currentProfile"() {
      if (!this.canViewReport) {
        this.$router.go(-1);
        this.$toast.show(
          "Only admins, reviewers and RQR leaders can access reports"
        );
        return;
      }
    },
  },
  
};
</script>
